<template>
<div>
    <div v-for="field in orderedFormFields"
         :key="field.key"
         class="field-group">
        <auto-field :field="field"
                    heading-class="field-group-heading strong"
                    v-model="field.value"
                    @change="setArgEmptiness(field.key, $event)"
                    :error="!!serverValidationMessages[field.key]"
                    :required="field.required"
                    :readonly="readonly || methodIsLocked"/>
        <span v-if="!!serverValidationMessages[field.key]"
              class="help-text error">
            {{ serverValidationMessages[field.key] }}
        </span>
    </div>
</div>
</template>

<script>
import AutoField from "./form_components/AutoField";

export default {
  name: "TaskParameters",

  components: {
    AutoField,
  },

  props: {
    fields: {
      type: Array,
      required: true,
    },
    methodIsLocked: {
        type: Boolean,
        default: false
    },

    // Server may reject formField value if it's invalid. In this case
    // this dictionary will contain some explanation why concrete field
    // is inappropriate.
    serverValidationMessages: {
      type: Object,
      required: false,
      default() { return {} },
    },

    // Makes parameters only viewable. All edit-related things will be
    // suppressed.
    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  computed: {
    // Sort fields in order in which required fields appear first
    orderedFormFields() {
      const fields = this.fields
      if (!Array.isArray(fields)) {
        return []
      }
      return [...fields].sort((one, other) => {
        return (one.required ? 0 : 1) - (other.required ? 0 : 1);
      })
    },

    // Returns dictionary of arguments that's supposed to be sent to
    // backend. Dictionary is cleared of meaningless parameters (which are
    // not required and values of which are correspond to default)
    preparedToSend() {
      let argsToSend = {};
      for (const field of this.fields) {
        if (field.required || !this.formEmptyArgs[field.key]) {
          argsToSend[field.key] = field.value;
        }
      }
      return argsToSend;
    },
  },

  data() {
    return {
      // Keeps track of which of formArgs are empty (we say that formArg
      // is empty if its value is equal to default)
      formEmptyArgs: {},
    }
  },

  methods: {
    setArgEmptiness(argName, isEmpty) {
      this.formEmptyArgs[argName] = isEmpty
    }
  },
}
</script>

<style scoped>

</style>
